<app-menu *ngIf="showMenu"></app-menu>
<router-outlet>
</router-outlet>

<notifier-container></notifier-container>